import LogRocket from 'logrocket';
export function identifyUserWithLogRocket(user) {
  try {
    console.log("LogRocket identity", user);
    LogRocket.identify(user.id, {
      name: user.name,
      email: user.email,
      role: user.role,
    });
  } catch (err) {
    console.log("LogRocket identity:err", err);
  }
}